import React, { useState, useEffect } from 'react';

const DriverForm = ({ onSave, editingDriver, onCancelEdit }) => {
  const initialState = {
    name: '',
    license: '',
    licenseType: 'Particular',
    phone: '',
    email: '',
    status: 'Activo'
  };

  const [formData, setFormData] = useState(initialState);
  const [errorMsg, setErrorMsg] = useState("");

  useEffect(() => {
    if (editingDriver) {
      setFormData(editingDriver);
    } else {
      setFormData(initialState);
    }
    setErrorMsg("");
  }, [editingDriver]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.name || !formData.license || !formData.email) {
      setErrorMsg("Nombre, licencia y email son requeridos");
      return;
    }
    try {
      const result = await onSave(formData);
      if (result && result.error) {
        setErrorMsg(result.error);
        return;
      }
      setFormData(initialState);
      setErrorMsg("");
      if (editingDriver && onCancelEdit) onCancelEdit();
    } catch (err) {
      setErrorMsg("Error al guardar el conductor");
    }
  };

  return (
    <div className="bg-white rounded-xl shadow-md p-6">
      <h3 className="text-lg font-bold mb-4">{editingDriver ? "Editar Conductor" : "Registrar Conductor"}</h3>
      <form onSubmit={handleSubmit}>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Nombre</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-md"
              required
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Número de Licencia</label>
            <input
              type="text"
              name="license"
              value={formData.license}
              onChange={handleChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-md"
              required
              disabled={!!editingDriver}
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Tipo de Licencia</label>
            <select
              name="licenseType"
              value={formData.licenseType}
              onChange={handleChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-md"
              required
            >
              <option value="Particular">Particular</option>
              <option value="Profesional">Profesional</option>
              <option value="Especial">Especial</option>
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Teléfono</label>
            <input
              type="text"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-md"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-md"
              required
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Estado</label>
            <select
              name="status"
              value={formData.status}
              onChange={handleChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-md"
            >
              <option value="Activo">Activo</option>
              <option value="Inactivo">Inactivo</option>
            </select>
          </div>
        </div>
        {errorMsg && (
          <div className="mb-2 text-red-600">{errorMsg}</div>
        )}
        <button
          type="submit"
          className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
        >
          {editingDriver ? "Guardar Cambios" : "Guardar Conductor"}
        </button>
        {editingDriver && (
          <button
            type="button"
            onClick={onCancelEdit}
            className="ml-2 px-4 py-2 bg-gray-400 text-white rounded-md hover:bg-gray-500"
          >
            Cancelar
          </button>
        )}
      </form>
    </div>
  );
};

export default DriverForm;